
import "./dashboardLayout.css"
import { useState } from "react";
import { useGlobalContext } from "../context/SocketContext";
import Header from "../pages/dashboard/Header";
import Sidebar from "../pages/dashboard/Sidebar";
function DashboardLayout({ children }) {
    const { globalState, setGlobalState } = useGlobalContext();
    return (
        <div className={`dashboardLayout dashboard_sec dashboard_sec_new ${!globalState ? "dash_transition" : ""}`}>
            <div className="container-fluid d-flex ps-0 pe-0">
                <div className={`left_side_sec ${globalState ? "sidebar_view" : "sidebar_hide"}`}>
                    <Sidebar />
                </div>
                <div className="right_side_sec">
                    <div className="">
                        <Header />
                    </div>
                    <div className="childrenWrapper">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DashboardLayout;
